import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../wrappers/UserContext'
import { Navigate } from 'react-router-dom'
import {
    checkRole,
    getRoles,
    hasAccessToAdmin,
} from '../../../utils/user/permissions'
import urls from '../../../utils/constants/urls'
import WithConfig from '../../wrappers/withConfig'

const RestrictedAccess = WithConfig(({ config, allowedRoles, children }) => {
    const { client } = useContext(UserContext)
    const [hasAccess, setHasAccess] = useState(true)
    const { USE_OKTA, ROLE_PREFIX, ROLE_ARRAY } = config

    useEffect(() => {
        const checkClientAccess = async (allowedRoles) => {
            try {
                await client.getUser().then((user) => {
                    const roles = getRoles(
                        user,
                        ROLE_ARRAY,
                        ROLE_PREFIX,
                        USE_OKTA
                    )

                    const hasRequiredAccess = allowedRoles.some((role) =>
                        checkRole(role, roles)
                    )
                    setHasAccess(hasRequiredAccess)
                })
            } catch (e) {
                setHasAccess(false)
            }
        }
        checkClientAccess(allowedRoles)
    }, [client, allowedRoles, USE_OKTA])

    if (hasAccess) {
        return children
    } else {
        return <Navigate to={urls.login} replace />
    }
})

export default RestrictedAccess
